import * as React from "react";
import {cx} from "emotion";

import "./paper-type.scss";

import {is3rdPartyWorkflow, isKit, isPickPack,
        isUyoMPB}          from "@Common/logic/template-options/template-options-pickpack-data-logic";
import {cs}                from "@Common/react/chain-services";
import {scn}               from "@Common/react/state-change-nested-value";
import {Select}            from "@Common/ui-components/heavy/common/design2/select/select";

import {Coating} from "./coating/coating";

export const PaperType = (
    {
        state, errorMessage, paperTypes, paperType, templateOptions, finishingTypes, totalQuantity, finishing,
        paperTypeEh, paperTypeErrDomRef,
        className, templateBack, templateBackId, oia,
    }
) => cs(
    () => (
        !isKit(templateOptions) && <div className={cx("paper-type-2e5", className)}>
            {errorMessage && (
                <div className={cx("card error", paperTypeEh.css)} ref={paperTypeErrDomRef.set} xd-qa-type="text" xd-qa-name="Error Message">
                    {errorMessage}
                </div>
            )}
            {!isPickPack(templateOptions) && !is3rdPartyWorkflow(templateOptions) && paperType && <>
                <div className="header">
                    <div className="title" xd-qa-type="label" xd-qa-name="Paper Type Label">Paper Type:</div>
                </div>

                {paperTypes.length === 1 ? (
                    <div className="value" xd-qa-type="text_field" xd-qa-name="Paper Type">
                        {paperType.name}
                    </div>
                ) : (
                    <div className="card">
                        <div className="select">
                            {Select({
                                list: paperTypes,
                                itemToLabel: (o) => o?.name,
                                itemToInfo: () => null,
                                onChange: (o) => scn(state, ["paperTypeId"], () => o.id),
                                isSelected: (o) => o.id === paperType?.id,
                                forcedExpandLeft: true,
                                xdQaName: "Paper Type",
                            })}
                        </div>
                    </div>
                )}
                <div className="card">
                    {Coating({
                        finishingTypes,
                        selected: finishing,
                        onSelect: (finishing) => scn(state, ["finishing"], () => finishing),
                        isUyoMPB: isUyoMPB(templateOptions),
                        templateBack,
                        templateBackId,
                        oia,
                        totalQuantity,
                    })}
                </div>
            </>}
        </div>
    ),
);
